module.exports = __webpack_public_path__ + "img/side-icon-42.dfbe9da7.svg";